module.exports = __webpack_public_path__ + "img/hampton-logo.88e32ca5.jpg";